import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { Select } from '@ngxs/store';
import { UiState } from '@ngxs-store/ui-store/ui.state';
import { Observable } from 'rxjs';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@core/animations/route.animations';

@Component({
  selector: 'app-main-content',
  template: `
  <div fxFlexFill fxLayout="column" [ngClass]="routeAnimationsElements" [class.web-content-spacing]="!noContentSpacing && (isMobileMode$ | async) === false" [class.mobile-content-spacing]="!noContentSpacing && (isMobileMode$ | async)">
    <ng-content></ng-content>
  </div>
  `,
  styles: [
    `
      :host(app-main-content) {
        height: 100%;
        min-height: 100%;
        min-width: 99%;
        width: 99%;
        flex-direction: column;
        box-sizing: border-box;
        display: flex;
      }

      .web-content-spacing {
        padding-top: 8px;
        padding-left: 16px;
        padding-right: 16px;
        padding-bottom: 16px;
      }

      .mobile-content-spacing {
        padding-top: 8px;
        padding-left: 8px;
        padding-right: 8px;
        padding-bottom: 8px;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainContentComponent implements OnInit {
  @Select(UiState.getIsMobileMode) isMobileMode$: Observable<boolean>;
  @Input() noContentSpacing = false;

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  constructor() { }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() { }
}
